<div class="spinner" *ngIf="isLoading$ | async">
  <img id="rwe-logo" src="https://tgt-cdn.trwe.net/logos/apps/engage/engage-logo_small.svg" />
</div>
